import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconCloudy({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4753 12.241C22.4233 12.241 22.3734 12.2469 22.3221 12.2489C21.7453 9.81373 19.5633 8 16.9519 8C14.2076 8 11.9375 10.0025 11.5074 12.6238C11.1648 12.5284 10.8051 12.4725 10.4322 12.4725C8.53235 12.4725 6.94616 13.7989 6.5404 15.5758C5.05417 16.1585 4 17.602 4 19.2947C4 21.501 5.78874 23.2898 7.99573 23.2898H22.4753C25.5273 23.2898 28 20.8164 28 17.7657C28 14.715 25.5273 12.2404 22.4753 12.2404V12.241Z"
        fill="white"
      />
    </svg>
  );
}
